/**
 * Sample Graph Data - JavaScript Version
 * 
 * Provides pre-built graph examples for testing and demonstration
 */

export const sampleGraphs = {
  simple: {
    name: "Simple 4-Node Graph",
    nodes: [
      { id: 1, label: "A", x: 100, y: 100 },
      { id: 2, label: "B", x: 300, y: 100 },
      { id: 3, label: "C", x: 100, y: 300 },
      { id: 4, label: "D", x: 300, y: 300 }
    ],
    edges: [
      { from_: 1, to: 2, length: 4, label: "A-B" },
      { from_: 1, to: 3, length: 2, label: "A-C" },
      { from_: 2, to: 4, length: 3, label: "B-D" },
      { from_: 3, to: 4, length: 5, label: "C-D" },
      { from_: 2, to: 3, length: 1, label: "B-C" }
    ]
  },
  
  complex: {
    name: "Complex 20-Node Network",
    nodes: [
      { id: 1, label: "A", x: 100, y: 100 },
      { id: 2, label: "B", x: 300, y: 100 },
      { id: 3, label: "C", x: 500, y: 100 },
      { id: 4, label: "D", x: 700, y: 100 },
      { id: 5, label: "E", x: 100, y: 200 },
      { id: 6, label: "F", x: 300, y: 200 },
      { id: 7, label: "G", x: 500, y: 200 },
      { id: 8, label: "H", x: 700, y: 200 },
      { id: 9, label: "I", x: 100, y: 300 },
      { id: 10, label: "J", x: 300, y: 300 },
      { id: 11, label: "K", x: 500, y: 300 },
      { id: 12, label: "L", x: 700, y: 300 },
      { id: 13, label: "M", x: 100, y: 400 },
      { id: 14, label: "N", x: 300, y: 400 },
      { id: 15, label: "O", x: 500, y: 400 },
      { id: 16, label: "P", x: 700, y: 400 },
      { id: 17, label: "Q", x: 200, y: 150 },
      { id: 18, label: "R", x: 400, y: 250 },
      { id: 19, label: "S", x: 600, y: 350 },
      { id: 20, label: "T", x: 800, y: 450 }
    ],
    edges: [
      { from_: 1, to: 2, length: 3, label: "A-B" },
      { from_: 2, to: 3, length: 4, label: "B-C" },
      { from_: 3, to: 4, length: 2, label: "C-D" },
      { from_: 1, to: 5, length: 5, label: "A-E" },
      { from_: 2, to: 6, length: 2, label: "B-F" },
      { from_: 3, to: 7, length: 3, label: "C-G" },
      { from_: 4, to: 8, length: 4, label: "D-H" },
      { from_: 5, to: 6, length: 1, label: "E-F" },
      { from_: 6, to: 7, length: 2, label: "F-G" },
      { from_: 7, to: 8, length: 3, label: "G-H" },
      { from_: 5, to: 9, length: 4, label: "E-I" },
      { from_: 6, to: 10, length: 2, label: "F-J" },
      { from_: 7, to: 11, length: 3, label: "G-K" },
      { from_: 8, to: 12, length: 2, label: "H-L" },
      { from_: 9, to: 10, length: 1, label: "I-J" },
      { from_: 10, to: 11, length: 2, label: "J-K" },
      { from_: 11, to: 12, length: 1, label: "K-L" },
      { from_: 9, to: 13, length: 3, label: "I-M" },
      { from_: 10, to: 14, length: 2, label: "J-N" },
      { from_: 11, to: 15, length: 3, label: "K-O" },
      { from_: 12, to: 16, length: 2, label: "L-P" },
      { from_: 13, to: 14, length: 1, label: "M-N" },
      { from_: 14, to: 15, length: 2, label: "N-O" },
      { from_: 15, to: 16, length: 1, label: "O-P" },
      { from_: 1, to: 17, length: 2, label: "A-Q" },
      { from_: 17, to: 2, length: 1, label: "Q-B" },
      { from_: 3, to: 18, length: 2, label: "C-R" },
      { from_: 18, to: 4, length: 1, label: "R-D" },
      { from_: 9, to: 19, length: 3, label: "I-S" },
      { from_: 19, to: 10, length: 2, label: "S-J" },
      { from_: 11, to: 20, length: 4, label: "K-T" },
      { from_: 20, to: 12, length: 1, label: "T-L" }
    ]
  },
  
  grid: {
    name: "5x5 Grid Network",
    nodes: [
      { id: 1, label: "A1", x: 100, y: 100 },
      { id: 2, label: "A2", x: 200, y: 100 },
      { id: 3, label: "A3", x: 300, y: 100 },
      { id: 4, label: "A4", x: 400, y: 100 },
      { id: 5, label: "A5", x: 500, y: 100 },
      { id: 6, label: "B1", x: 100, y: 200 },
      { id: 7, label: "B2", x: 200, y: 200 },
      { id: 8, label: "B3", x: 300, y: 200 },
      { id: 9, label: "B4", x: 400, y: 200 },
      { id: 10, label: "B5", x: 500, y: 200 },
      { id: 11, label: "C1", x: 100, y: 300 },
      { id: 12, label: "C2", x: 200, y: 300 },
      { id: 13, label: "C3", x: 300, y: 300 },
      { id: 14, label: "C4", x: 400, y: 300 },
      { id: 15, label: "C5", x: 500, y: 300 },
      { id: 16, label: "D1", x: 100, y: 400 },
      { id: 17, label: "D2", x: 200, y: 400 },
      { id: 18, label: "D3", x: 300, y: 400 },
      { id: 19, label: "D4", x: 400, y: 400 },
      { id: 20, label: "D5", x: 500, y: 400 },
      { id: 21, label: "E1", x: 100, y: 500 },
      { id: 22, label: "E2", x: 200, y: 500 },
      { id: 23, label: "E3", x: 300, y: 500 },
      { id: 24, label: "E4", x: 400, y: 500 },
      { id: 25, label: "E5", x: 500, y: 500 }
    ],
    edges: [
      // Horizontal connections
      { from_: 1, to: 2, length: 1, label: "A1-A2" },
      { from_: 2, to: 3, length: 1, label: "A2-A3" },
      { from_: 3, to: 4, length: 1, label: "A3-A4" },
      { from_: 4, to: 5, length: 1, label: "A4-A5" },
      { from_: 6, to: 7, length: 1, label: "B1-B2" },
      { from_: 7, to: 8, length: 1, label: "B2-B3" },
      { from_: 8, to: 9, length: 1, label: "B3-B4" },
      { from_: 9, to: 10, length: 1, label: "B4-B5" },
      { from_: 11, to: 12, length: 1, label: "C1-C2" },
      { from_: 12, to: 13, length: 1, label: "C2-C3" },
      { from_: 13, to: 14, length: 1, label: "C3-C4" },
      { from_: 14, to: 15, length: 1, label: "C4-C5" },
      { from_: 16, to: 17, length: 1, label: "D1-D2" },
      { from_: 17, to: 18, length: 1, label: "D2-D3" },
      { from_: 18, to: 19, length: 1, label: "D3-D4" },
      { from_: 19, to: 20, length: 1, label: "D4-D5" },
      { from_: 21, to: 22, length: 1, label: "E1-E2" },
      { from_: 22, to: 23, length: 1, label: "E2-E3" },
      { from_: 23, to: 24, length: 1, label: "E3-E4" },
      { from_: 24, to: 25, length: 1, label: "E4-E5" },
      
      // Vertical connections
      { from_: 1, to: 6, length: 1, label: "A1-B1" },
      { from_: 2, to: 7, length: 1, label: "A2-B2" },
      { from_: 3, to: 8, length: 1, label: "A3-B3" },
      { from_: 4, to: 9, length: 1, label: "A4-B4" },
      { from_: 5, to: 10, length: 1, label: "A5-B5" },
      { from_: 6, to: 11, length: 1, label: "B1-C1" },
      { from_: 7, to: 12, length: 1, label: "B2-C2" },
      { from_: 8, to: 13, length: 1, label: "B3-C3" },
      { from_: 9, to: 14, length: 1, label: "B4-C4" },
      { from_: 10, to: 15, length: 1, label: "B5-C5" },
      { from_: 11, to: 16, length: 1, label: "C1-D1" },
      { from_: 12, to: 17, length: 1, label: "C2-D2" },
      { from_: 13, to: 18, length: 1, label: "C3-D3" },
      { from_: 14, to: 19, length: 1, label: "C4-D4" },
      { from_: 15, to: 20, length: 1, label: "C5-D5" },
      { from_: 16, to: 21, length: 1, label: "D1-E1" },
      { from_: 17, to: 22, length: 1, label: "D2-E2" },
      { from_: 18, to: 23, length: 1, label: "D3-E3" },
      { from_: 19, to: 24, length: 1, label: "D4-E4" },
      { from_: 20, to: 25, length: 1, label: "D5-E5" }
    ]
  }
};

// Default graph function
export const getDefaultGraph = () => {
  return {
    nodes: [...sampleGraphs.simple.nodes],
    edges: [...sampleGraphs.simple.edges]
  };
};

/**
 * Get all sample graphs
 */
export const getSampleGraphs = () => {
  return sampleGraphs;
};

// Graph validation function
export const validateGraph = (graphData) => {
  const errors = [];
  
  if (!graphData || !graphData.nodes || !graphData.edges) {
    errors.push("Graph data must have nodes and edges properties");
    return { isValid: false, errors };
  }
  
  if (!Array.isArray(graphData.nodes)) {
    errors.push("Nodes must be an array");
  }
  
  if (!Array.isArray(graphData.edges)) {
    errors.push("Edges must be an array");
  }
  
  if (graphData.nodes.length === 0) {
    errors.push("Graph must have at least one node");
  }
  
  // Validate node structure
  graphData.nodes.forEach((node, index) => {
    if (!node.id || !node.label || node.x === undefined || node.y === undefined) {
      errors.push(`Node at index ${index} is missing required properties (id, label, x, y)`);
    }
  });
  
  // Validate edge structure
  graphData.edges.forEach((edge, index) => {
    if (!edge.from_ || !edge.to || edge.length === undefined) {
      errors.push(`Edge at index ${index} is missing required properties (from_, to, length)`);
    }
  });
  
  return {
    isValid: errors.length === 0,
    errors
  };
};
